<div id="middle-header">
    <div class="container-fluid px-xl-3 px-xxl-5 py-2">
        <div class="row d-flex align-items-center justify-content-between">

            <!-- Logo -->
            <div class="col-12 col-md-5 text-center text-md-start mb-2 mb-md-0">
                <a class="navbar-brand py-0" routerLink="/">
                    <img src="/assets/img/logo/1.png" alt="Logo" class="img-fluid" style="max-height: 500px;">
                </a>
            </div>

            <!-- Top Header Buttons -->
            <div
                class="col-12 col-md-7 text-center text-md-end d-flex justify-content-center justify-content-md-end align-items-center flex-wrap gap-2">
                <a href="https://data.odpay.in/odforms1/form/AryakulamInternationalSchoolAdmissionQueryForm/formperma/DetjGBWCRvnFof5r74d4wpnrYYK7OScNBZnZLcbT7D4"
                    target="_blank" class="btn header-btn">Admissions Open 2026-27</a>
                <a href="https://student.okiedokiepay.com/ResolveAuth" target="_blank" class="btn header-btn">Fee
                    Payment</a>
                <a routerLink="/mandatory-public-disclosure" class="btn header-btn">Mandatory Public Disclosure</a>
                <!-- <a routerLink="/cbse-firebase" class="btn header-btn">CBSE </a> -->
            </div>

        </div>
    </div>
</div>


<!-- Main Header Start -->
<div id="header">
    <div class="container-fluid px-0">
        <div class="row d-flex align-items-center py-0 mx-0">
            <div class="col-12 px-0">
                <nav class="navbar navbar-expand-lg py-0">
                    <div class="container-fluid px-0">
                        <div class="d-flex d-md-none justify-content-between align-items-center w-100 px-3 py-2">
                            <a href="https://data.odpay.in/odforms1/form/SNPSNirankariColony/formperma/yscGTjwuuDVFZnOEuKzbq1COWTcGTjdwydq3UwFCpKE"
                                target="_blank" class="btn px-3 text-white"
                                style="background-color: var(--secondary);">Admissions Open</a>
                            <button class="navbar-toggler border-0" type="button" data-bs-toggle="collapse"
                                data-bs-target="#menu" aria-controls="menu" aria-expanded="false"
                                aria-label="Toggle navigation">
                                <i class="fa-solid fa-bars text-white"></i> Menu
                            </button>
                        </div>
                        <div class="collapse navbar-collapse" id="menu">
                            <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
                                <li class="nav-item">
                                    <a class="nav-link active" aria-current="page" routerLink="/">Home</a>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(0, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(0, false)"
                                    (click)="isMobileScreen && toggleDropdown(0, true)"
                                    [class.show]="dropdownStates[0]">
                                    <a class="nav-link dropdown-toggle" routerLink="/about" id="navbarDropdown0"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">About</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown0"
                                        [class.show]="dropdownStates[0]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/history">About AIS</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/mission-vision">Mission of AIS</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/mission-vision">Vision of AIS</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/logo">Meaning of AIS Logo</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/principal">Principal Message</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/chairperson">Chairman Message</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/rules-regulations">AIS Rules and Regulation</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/affidavit">Non-Profit Affidavit</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/core-values">Core Values of AIS</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(1, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(1, false)"
                                    (click)="isMobileScreen && toggleDropdown(1, true)"
                                    [class.show]="dropdownStates[1]">
                                    <a class="nav-link dropdown-toggle" routerLink="/admission" id="navbarDropdown1"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Admission</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown1"
                                        [class.show]="dropdownStates[1]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(1)"
                                                routerLink="/admission/process">Admission Procedure</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(1)"
                                                routerLink="/admission/age-criteria">Age Criteria for Admission</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(1)"
                                                routerLink="/admission/entrance-syllabus">Entranced Syllabus</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(1)"
                                                routerLink="/admission/admission-form">Admission Form</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(1)"
                                                routerLink="/admission/fee-structure">Fee Rules</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(1)"
                                                routerLink="/admission/withdrawal">Admission Withdrawal Process</a>
                                        </li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(2, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(2, false)"
                                    (click)="isMobileScreen && toggleDropdown(2, true)"
                                    [class.show]="dropdownStates[2]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown2"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Academics</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown2"
                                        [class.show]="dropdownStates[2]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(2)"
                                                routerLink="/academics/calendar">School Calander</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(2)"
                                                routerLink="/academics/conduct">Code of Conduct</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(2)"
                                                routerLink="/academics/subjects-xi">Subject for XI</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(2)"
                                                routerLink="/academics/prescribed-books">Prescribed Books</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(2)"
                                                routerLink="/academics/syllabus">Class Wise Syllabus</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(2)"
                                                routerLink="/academics/scholarship">Scholarship</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(2)"
                                                routerLink="/academics/counselling">Career Counselling</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(2)"
                                                routerLink="/academics/ptm">Parents Teacher Meeting (PTM)</a>
                                        </li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(3, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(3, false)"
                                    (click)="isMobileScreen && toggleDropdown(3, true)"
                                    [class.show]="dropdownStates[3]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown3"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Student's Life</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown3"
                                        [class.show]="dropdownStates[3]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(3)"
                                                routerLink="/student-life/full-day">Full Day of AIS</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(3)"
                                                routerLink="/student-life/timings">School Timings</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(3)"
                                                routerLink="/student-life/uniform">School Uniform</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(3)"
                                                routerLink="/student-life/house-system">House System</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(3)"
                                                routerLink="/student-life/clubs">Clubs of AIS</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(3)"
                                                routerLink="/student-life/library">Library System</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(4, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(4, false)"
                                    (click)="isMobileScreen && toggleDropdown(4, true)"
                                    [class.show]="dropdownStates[4]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown4"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Infrastructure</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown4"
                                        [class.show]="dropdownStates[4]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(4)"
                                                routerLink="/infrastructure/safety">Safety and Security Measures</a>
                                        </li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(4)"
                                                routerLink="/infrastructure/campus">Infrastructure</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(4)"
                                                routerLink="/infrastructure/features">AIS Feature</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(5, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(5, false)"
                                    (click)="isMobileScreen && toggleDropdown(5, true)"
                                    [class.show]="dropdownStates[5]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown5"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Faculty</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown5"
                                        [class.show]="dropdownStates[5]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(5)"
                                                routerLink="/faculty/academic-staff">Academic Staff</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(5)"
                                                routerLink="/faculty/administrative-staff">Administrative Staff</a></li>
                                        <!-- <li><a class="dropdown-item text-primary fw-semibold" (click)="closeDropdown(5)"
                                                routerLink="/firebase-faculty"> Faculty</a></li> -->
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(6, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(6, false)"
                                    (click)="isMobileScreen && toggleDropdown(6, true)"
                                    [class.show]="dropdownStates[6]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown6"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Transport</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown6"
                                        [class.show]="dropdownStates[6]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(6)"
                                                routerLink="/transport/transport-info">About Transport</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(6)"
                                                routerLink="/transport/rules">Transport Rules</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(6)"
                                                routerLink="/transport/safety">Transport Safety</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(6)"
                                                routerLink="/transport/guidelines">Transport Guidelines</a>
                                        </li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(6)"
                                                routerLink="/transport/connectivity">Transport Connectivity</a>
                                        </li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(7, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(7, false)"
                                    (click)="isMobileScreen && toggleDropdown(7, true)"
                                    [class.show]="dropdownStates[7]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown7"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Committee</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown7"
                                        [class.show]="dropdownStates[7]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(7)"
                                                routerLink="/committee/smc">School Management Committee</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(7)"
                                                routerLink="/committee/pta">Parents Teacher Association
                                                (PTA)</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(7)"
                                                routerLink="/committee/disciplinary">Disciplinary Committee</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(7)"
                                                routerLink="/committee/anti-bullying">Anti-Bullying Committee</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(7)"
                                                routerLink="/committee/pocso">POCSO Committee</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(7)"
                                                routerLink="/committee/disaster-management">Disaster Management
                                                Committee</a>
                                        </li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(7)"
                                                routerLink="/committee/transport-safety">School Transportation Safety
                                                Committee</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(7)"
                                                routerLink="/committee/grievance-redressal">Grievance Redressal
                                                Committee</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(7)"
                                                routerLink="/committee/anti-tobacco-drug">Anti-Tobacco & Drug
                                                Committee</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(8, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(8, false)"
                                    (click)="isMobileScreen && toggleDropdown(8, true)"
                                    [class.show]="dropdownStates[8]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown8"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Sports
                                        Facilities</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown8"
                                        [class.show]="dropdownStates[8]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(8)"
                                                routerLink="/sports/infrastructure">Sports Infrastructure</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(8)"
                                                routerLink="/sports/indoor">Indoor Games</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(8)"
                                                routerLink="/sports/outdoor">Outdoor Games</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(9, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(9, false)"
                                    (click)="isMobileScreen && toggleDropdown(9, true)"
                                    [class.show]="dropdownStates[9]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown9"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Other</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown9"
                                        [class.show]="dropdownStates[9]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(9)"
                                                routerLink="/news-events/latest-news">Latest News</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(9)"
                                                routerLink="/news-events/upcoming-events">Upcoming Events</a></li>
                                    </ul>
                                </li>
                                <!-- <li class="nav-item">
                                    <a class="nav-link" routerLink="/cbse-firebase">CBSE </a>
                                </li> -->
                                <!-- <li class="nav-item">
                                    <a class="nav-link" routerLink="/firebase-faculty">Faculty</a>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</div>
<!-- Main Header End -->

<!-- Scroll Header Start -->
<div id="header1">
    <div class="container-fluid px-0">
        <div class="row d-flex align-items-center py-0 mx-0">
            <div class="col-12 px-0">
                <nav class="navbar navbar-expand-lg py-0">
                    <div class="container-fluid position-relative px-0">
                        <div class="shadow d-none d-lg-block"
                            style="background: white; border-radius: 0 0 20px 20px; position: absolute; top: 0; padding: 8px; left: 20px;">
                            <a class="navbar-brand py-2 text-center" routerLink="/"><img src="/assets/img/logo/1.png"
                                    alt="Logo" style="height: 60px;" class="img-fluid"></a>
                        </div>
                        <div class="collapse navbar-collapse" id="menu1" style="height: 50px;">
                            <ul class="navbar-nav ms-auto mb-2 mb-lg-0 pe-5">
                                <li class="nav-item">
                                    <a class="nav-link active" aria-current="page" routerLink="/">Home</a>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(0, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(0, false)"
                                    (click)="isMobileScreen && toggleDropdown(0, true)"
                                    [class.show]="dropdownStates[0]">
                                    <a class="nav-link dropdown-toggle" routerLink="/about" id="navbarDropdown1_0"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">About</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown1_0"
                                        [class.show]="dropdownStates[0]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/history">About AIS</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/mission-vision">Mission of AIS</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(0)"
                                                routerLink="/about/core-values">Core Values</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(1, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(1, false)"
                                    (click)="isMobileScreen && toggleDropdown(1, true)"
                                    [class.show]="dropdownStates[1]">
                                    <a class="nav-link dropdown-toggle" routerLink="/admission" id="navbarDropdown1_1"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Admission</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown1_1"
                                        [class.show]="dropdownStates[1]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(1)"
                                                routerLink="/admission/process">Procedure</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(1)"
                                                routerLink="/admission/admission-form">Admission Form</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(2, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(2, false)"
                                    (click)="isMobileScreen && toggleDropdown(2, true)"
                                    [class.show]="dropdownStates[2]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown1_2"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Academics</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown1_2"
                                        [class.show]="dropdownStates[2]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(2)"
                                                routerLink="/academics/syllabus">Syllabus</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(2)"
                                                routerLink="/academics/calendar">Calendar</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(3, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(3, false)"
                                    (click)="isMobileScreen && toggleDropdown(3, true)"
                                    [class.show]="dropdownStates[3]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown1_3"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Student's Life</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown1_3"
                                        [class.show]="dropdownStates[3]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(3)"
                                                routerLink="/student-life/house-system">House System</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(3)"
                                                routerLink="/student-life/clubs">Clubs</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(4, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(4, false)"
                                    (click)="isMobileScreen && toggleDropdown(4, true)"
                                    [class.show]="dropdownStates[4]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown1_4"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Infrastructure</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown1_4"
                                        [class.show]="dropdownStates[4]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(4)"
                                                routerLink="/infrastructure/campus">Facilities</a></li>
                                        <li><a class="dropdown-item" (click)="closeDropdown(4)"
                                                routerLink="/infrastructure/features">Features</a></li>
                                    </ul>
                                </li>

                                <!-- <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(5, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(5, false)"
                                    (click)="isMobileScreen && toggleDropdown(5, true)"
                                    [class.show]="dropdownStates[5]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown1_5"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Faculty</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown1_5"
                                        [class.show]="dropdownStates[5]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(5)"
                                                routerLink="/academics/faculties">Staff</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(6, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(6, false)"
                                    (click)="isMobileScreen && toggleDropdown(6, true)"
                                    [class.show]="dropdownStates[6]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown1_6"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Transport</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown1_6"
                                        [class.show]="dropdownStates[6]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(6)"
                                                routerLink="/activities/scholastic-roadmap">Routes</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(7, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(7, false)"
                                    (click)="isMobileScreen && toggleDropdown(7, true)"
                                    [class.show]="dropdownStates[7]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown1_7"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Committee</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown1_7"
                                        [class.show]="dropdownStates[7]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(7)"
                                                routerLink="/activities/committees">Committees</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(8, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(8, false)"
                                    (click)="isMobileScreen && toggleDropdown(8, true)"
                                    [class.show]="dropdownStates[8]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown1_8"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Sports
                                        Facilities</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown1_8"
                                        [class.show]="dropdownStates[8]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(8)"
                                                routerLink="/media/photo-gallery">Sports</a></li>
                                    </ul>
                                </li> -->

                                <li class="nav-item dropdown" (mouseenter)="!isMobileScreen && toggleDropdown(9, true)"
                                    (mouseleave)="!isMobileScreen && toggleDropdown(9, false)"
                                    (click)="isMobileScreen && toggleDropdown(9, true)"
                                    [class.show]="dropdownStates[9]">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown1_9"
                                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Other</a>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown1_9"
                                        [class.show]="dropdownStates[9]">
                                        <li><a class="dropdown-item" (click)="closeDropdown(9)"
                                                routerLink="/news-events/latest-news">News</a></li>
                                    </ul>
                                </li>
                                <!-- <li class="nav-item">
                                    <a class="nav-link" routerLink="/cbse-firebase">CBSE </a>
                                </li> -->
                                <!-- <li class="nav-item">
                                    <a class="nav-link" routerLink="/firebase-faculty">Faculty</a>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</div>
<!-- Scroll Header End -->

<div id="bring-top" class="d-none">
    <div class="top-box d-flex justify-content-center align-items-center shadow" (click)="bringToTop()">
        <i class="fa-solid fa-arrow-up"></i>
    </div>
</div>

<!-- show only on home -->
<div id="side-quick-links" *ngIf="isHomePage">
    <ul>
        <li class="facebook">
            <div class="content">
                <a href="https://www.facebook.com/aryakulammunak" target="_blank" class="icons"><i
                        class="fa-brands fa-facebook-f" aria-hidden="true"></i></a>
                <p><a href="https://www.facebook.com/aryakulammunak" target="_blank">Facebook</a></p>
            </div>
        </li>
        <li class="insta">
            <div class="content">
                <a href="https://www.instagram.com/aismunak" target="_blank" class="icons"><i
                        class="fa-brands fa-instagram" aria-hidden="true"></i></a>
                <p><a href="https://www.instagram.com/aismunak" target="_blank">Instagram</a></p>
            </div>
        </li>
        <li class="youtube">
            <div class="content">
                <a href="https://www.youtube.com/@aismunak" target="_blank" class="icons"><i
                        class="fa-brands fa-youtube" aria-hidden="true"></i></a>
                <p><a href="https://www.youtube.com/@aismunak" target="_blank">Youtube</a></p>
            </div>
        </li>
        <li class="contact">
            <div class="content">
                <a href="tel:9466252191" class="icons"><i class="fa fa-phone" aria-hidden="true"></i></a>
                <p><a href="tel:9466252191">Contact Us</a></p>
            </div>
        </li>
    </ul>
</div>

<!-- Apply Now Button -->
<a class="btn mandatory"
    href="https://data.odpay.in/odforms1/form/AryakulamInternationalSchoolAdmissionQueryForm/formperma/DetjGBWCRvnFof5r74d4wpnrYYK7OScNBZnZLcbT7D4"
    target="_blank" *ngIf="isHomePage">
    Apply Now
</a>

<!-- Virtual Tour Button -->
<button class="btn mandatory virtual-tour" data-bs-toggle="modal" data-bs-target="#headerTourModal"
    (click)="openVideo()" *ngIf="isHomePage">
    Campus Tour
</button>

<div class="modal fade" id="headerTourModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg custom-tour-modal">
        <div class="modal-content glass-cinema-content">
            <div class="modal-header border-0 pb-2">
                <h2 class="modal-title-custom mb-0">Campus Tour</h2>
                <button type="button" class="btn-close-custom" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="video-screen-wrapper">
                    <iframe *ngIf="isVideoActive" width="100%" height="480"
                        src="https://drive.google.com/file/d/1l9cjuWAC13-udKrpScIiO0JTwEjIIrc2/preview" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen>
                    </iframe>
                </div>
            </div>
        </div>
    </div>
</div>